function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M61 120.586L31.301 90.887C14.9 74.485 14.9 47.892 31.301 31.49c16.402-16.403 42.996-16.403 59.398 0 16.402 16.402 16.402 42.995 0 59.397L61 120.586z",
  stroke: "currentColor",
  strokeWidth: 2
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M39.249 66.522V43.697h43.393l-.137 22.825c0 14-15.085 25.565-21.628 25.565-6.544 0-21.628-11.565-21.628-25.565zM75 52L50 77",
  stroke: "currentColor",
  strokeWidth: 2
});

var SvgEmblemFoundationalElements = function SvgEmblemFoundationalElements(props) {
  return React.createElement("svg", _extends({
    width: 122,
    height: 122,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgEmblemFoundationalElements;